import React from 'react';
import { IconOpenLinkBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface Props {
  shop_department: string;
  onClick: () => void;
}
export const MetaStylePdpLink: React.FC<React.PropsWithChildren<Props>> = ({ shop_department, onClick }) => {
  return (
    <LinkButton onClick={onClick}>
      <p className={Typography.BODY_13_REGULAR}>해당 {shop_department}에서 정보를 확인하고 싶나요?</p>
      <button className={Typography.BODY_13_SEMIBOLD}>
        <IconOpenLinkBold size={16} />
        {shop_department} 바로가기
      </button>
    </LinkButton>
  );
};

const LinkButton = styled.div`
  padding: 28px 16px 24px 16px;
  border-bottom: 1px solid ${vars.v3Color.gray100};

  p {
    margin-bottom: 14px;
    color: ${vars.v3Color.gray700};
    text-align: center;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    color: ${vars.v3Color.gray900};
    border-radius: 8px;
    background-color: ${vars.v3Color.gray150};
  }
`;
